module.exports = __webpack_public_path__ + "./images/03f2303e79dfad231f6ff19aa848d51c.webp";